/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

document.addEventListener("DOMContentLoaded", function () {
    const observeTarget = document.body;

    const isMobile = window.matchMedia("(max-width: 767px)").matches;

    if (!isMobile) return;

    const targetClasses = [
        "gorgias-chat-key-76gqfx"
    ];

    const observer = new MutationObserver(() => {
        targetClasses.forEach((className) => {
            const scrollElements = document.querySelectorAll(`.${className}`);

            scrollElements.forEach((element) => {
                if (!element.scrollEventListenerAdded) {
                    element.scrollEventListenerAdded = true;

                    element.style.opacity = "0";
                    element.style.transition = "opacity 0.3s ease-in-out";

                    const showThreshold = 100;
                    const hideThreshold = 0;

                    window.addEventListener("scroll", function () {
                        const scrollTop = window.scrollY || document.documentElement.scrollTop;

                        if (scrollTop > showThreshold) {
                            element.style.transition = "opacity 0.3s ease-in-out";
                            element.style.opacity = "1";
                        } else if (scrollTop <= hideThreshold) {
                            element.style.transition = "opacity 0.3s ease-in-out";
                            element.style.opacity = "0";
                        }
                    });
                }
            });
        });

        const shadowHosts = document.querySelectorAll("equally-widget-ui");

        shadowHosts.forEach((host) => {
            const shadowRoot = host.shadowRoot;
            if (shadowRoot) {
                const buttonElement = shadowRoot.querySelector("button");

                if (buttonElement && !buttonElement.scrollEventListenerAdded) {
                    buttonElement.scrollEventListenerAdded = true;

                    buttonElement.style.opacity = "0";
                    buttonElement.style.transition = "opacity 0.3s ease-in-out";

                    const showThreshold = 100;
                    const hideThreshold = 0;

                    window.addEventListener("scroll", function () {
                        const scrollTop = window.scrollY || document.documentElement.scrollTop;

                        if (scrollTop > showThreshold) {
                            buttonElement.style.transition = "opacity 0.3s ease-in-out";
                            buttonElement.style.opacity = "1";
                        } else if (scrollTop <= hideThreshold) {
                            buttonElement.style.transition = "opacity 0.3s ease-in-out";
                            buttonElement.style.opacity = "0";
                        }
                    });
                }
            }
        });
    });

    observer.observe(observeTarget, { childList: true, subtree: true });
});









document.addEventListener("DOMContentLoaded", function () {
    const observeTarget = document.body;

    const observer = new MutationObserver(() => {
        const shadowHosts = document.querySelectorAll("equally-widget-ui");
        shadowHosts.forEach((host) => {
            const shadowRoot = host.shadowRoot;
            if (shadowRoot) {
                const shadowElement = shadowRoot.querySelector(".equally-ai___fab"); 
                if (shadowElement) {
                    const screenWidth = window.innerWidth;

                    if (screenWidth <= 767) {
                        shadowElement.style.top = "auto";
                        shadowElement.style.bottom = "27px";
                        shadowElement.style.right = "90px";
                        shadowElement.style.width = "50px";
                        shadowElement.style.height = "50px";
 
                    } else {
                        shadowElement.style.top = "auto";
                        shadowElement.style.bottom = "27px";
                        shadowElement.style.right = "102px";
                        shadowElement.style.width = "60px";
                        shadowElement.style.height = "60px";
                    }
                }
            }
        });
    });

    observer.observe(observeTarget, { childList: true, subtree: true });
});


document.addEventListener("DOMContentLoaded", function () {
    const isMobile = window.matchMedia("(max-width: 767px)").matches;

    if (!isMobile) return;

    const showThreshold = 100;
    const hideThreshold = 0;
    const observeTarget = document.body;

    const observer = new MutationObserver(() => {
        const shadowHosts = document.querySelectorAll(".mcforms-wrapper");

        shadowHosts.forEach((host) => {
            const shadowRoot = host.shadowRoot;

            if (shadowRoot) {
                const elDiv = shadowRoot.querySelector("#el__AfHMqnKhd");

                if (elDiv && !elDiv.initialized) {
                    elDiv.initialized = true;

                    // Immediately hide the element
                    elDiv.style.opacity = "0";
                    elDiv.style.transition = "none"; 
                    elDiv.style.animation = "none"; 
                    elDiv.style.visibility = "hidden"; 

                    // Set up the scroll listener for showing/hiding
                    window.addEventListener("scroll", function () {
                        const scrollTop = window.scrollY || document.documentElement.scrollTop;

                        if (scrollTop > showThreshold) {
                            elDiv.style.transition = "opacity 0.3s ease-in-out";
                            elDiv.style.visibility = "visible";
                            elDiv.style.opacity = "1";
                        } else if (scrollTop <= hideThreshold) {
                            elDiv.style.opacity = "0";
                            elDiv.style.visibility = "hidden";
                        }
                    });
                }
            }
        });
    });

    observer.observe(observeTarget, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", function () {
    const isMobile = window.matchMedia("(max-width: 767px)").matches;

    if (!isMobile) return;

    const showThreshold = 100; 
    const displayTimeout = 10000;
    const observeTarget = document.body;

    const observer = new MutationObserver(() => {
        const mcWrappers = document.querySelectorAll(".mcforms-wrapper");

        mcWrappers.forEach((wrapper) => {
            if (!wrapper.logicApplied) {
                wrapper.logicApplied = true;

                wrapper.style.display = "none";

                const showWrapper = () => {
                    wrapper.style.display = "block";
                };

            
                const onScroll = () => {
                    const scrollTop = window.scrollY || document.documentElement.scrollTop;

                    if (scrollTop > showThreshold) {
                        showWrapper();
                        window.removeEventListener("scroll", onScroll); 
                    }
                };

              
                window.addEventListener("scroll", onScroll);

             
                setTimeout(() => {
                    showWrapper();
                    window.removeEventListener("scroll", onScroll); 
                }, displayTimeout);
            }
        });
    });

    observer.observe(observeTarget, { childList: true, subtree: true });
});



document.addEventListener("DOMContentLoaded", function () {
    const observeTarget = document.body;

    const observer = new MutationObserver(() => {
        const shadowHosts = document.querySelectorAll(".mcforms-wrapper");
        shadowHosts.forEach((host) => {
            const shadowRoot = host.shadowRoot;
            if (shadowRoot) {
                const shadowElement = shadowRoot.querySelector("#el__AfHMqnKhd"); 
                if (shadowElement) {
                    const screenWidth = window.innerWidth;

                    if (screenWidth <= 767) {
                        shadowElement.style.bottom = "24px";
 
                    }
                }
            }
        });
    });

    observer.observe(observeTarget, { childList: true, subtree: true });
});







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
